var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"operation-context-alert",attrs:{"dense":"","outlined":"","color":"primary","icon":false}},[_c('div',{staticClass:"d-flex align-center"},[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"primary"}},[_vm._v("mdi-information")]),_c('div',{staticClass:"operation-context-alert__text"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }